<template>
	<div class="home-portfolio">
		<header class="fade-in-bottom-small">
			<span class="theme-color">Investment</span>
			portfolio
		</header>
		<h5>{{ $t('简单，安全。搜索热门投资，立即赚取收益') }}</h5>
		<ul class="list">
			<li class="item" v-for="(item, index) in data" :key="item.id + 'a'">
				<span class="index">{{ index + 1 }}</span>
				<span class="row">
					<span class="logos">
						<img alt="" :src="itemS" v-for="(itemS, index) in item.images" :key="index"
							class="lazy-img coin1">
					</span>
					<span class="productName">{{ item.invest }}</span>
				</span>
				<span class="column">
					<span class="theme-color h_40">APR</span>
					<span>{{ item.ratemax }}%</span>
				</span>
				<span class="column flex-end">
					<span class="theme-color h_40">{{$t('运行时常')}}</span>
					<span>{{ item.days }}日</span>
				</span>
			</li>
		</ul>
		<button class="cm-btn-animation1">
			<span>{{$t('了解投资组合')}}</span>
			<img src="@/assets/img-pc/33.5a9cc0e8.svg">
		</button>
	</div>
</template>
<script>
export default {
	props: {
		data: {
			type: Array,
			default: () => [],
		},
	},
	components: {},
	data() {
		return {};
	},
	methods: {

	},
};
</script>
<style lang="scss" scoped>
.home-portfolio {
	margin-bottom: 120px;

	.list {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		list-style: none;

		.item {
			width: calc(50% - 20px);
			height: 120px;
			border-radius: 18px;
			background: #0d0e0f;
			display: flex;
			align-items: center;
			padding: 0 30px;
			margin-bottom: 30px;
			cursor: pointer;
			font-size: 18px;

			.column {
				display: flex;
				flex-direction: column;

				.h_40 {
					height: 40px;
					line-height: 40px;
					margin-bottom: 10px;
				}
			}

			.flex-end {
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				margin-left: auto;
			}

			.row {
				display: flex;
				flex-direction: column;
				flex: none;
				min-width: 170px;
				margin-right: 20px;

				.logos {
					margin-bottom: 10px;

					.lazy-img {
						width: 40px;
						height: 40px;
						margin: 0;
						border-radius: 50%;
						margin-left: -10px;
					}
				}
			}

			.index {
				color: #fff;
				text-align: center;
				font-size: 32px;
				font-weight: 600;
				letter-spacing: 6px;
				margin-right: 30px;
				transition: all .2s;
			}
		}
	}

	.fade-in-bottom-small {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 50px;
		line-height: 60px;
		margin-bottom: 40px;
	}

	h5 {
		color: #cbd9da;
		font-size: 24px;
		line-height: 26px;
		text-align: center;
		margin-top: 40px;
		margin-bottom: 90px;
	}
}

.theme-color {
	color: #00f0ff !important;
}

.cm-btn-animation1 {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	min-width: 200px;
	height: 44px;
	padding: 14px 60px;
	border: 1px solid #333;
	background-color: #000;
	color: #fff;
	font-size: 18px;
	border-radius: 24px;
	margin: 20px auto 0;
	cursor: pointer;
	overflow: hidden;
	min-width: 268px;
	margin: 20px auto 0;

	img {
		transition: all .2s;
		margin-left: 15px;
	}
}
</style>